export const GRAPH_COLOR = 'rgba(0, 200, 83, 0.25)';
export const STROKE_COLOR = '#00C853';

export const BAR_STROKE_COLOR = 'rgba(0, 200, 83, 0.5)';
export const RED_STROKE_COLOR = 'rgb(245, 0, 87)';
